window.clientId = utils.isDev() ? 'gm8jcf9d1xwtzvbc304rgiwumh2s91' : 'hirnpvya5piis4k4n23dntu6of9bi6';
window.apiUrl = 'https://api.twitch.tv/helix/';
window.headers = { 
  'Client-ID': clientId,
  'Authorization': `Bearer ${utils.cookies.get('access_token')}` 
}

window.twitchAPI = {
  getUser: function(userId, callback) {
    // axios.get(`/api/user/get.php?twitchId=${userId}`, {
    //     headers: headers
    //   })
    userService.get({userId: userId})
      .then(function (response) {
        callback(response.data.data[0]);
      })
      .catch(function (error) {
        if (error.response.status == 401) {
          authentication.refreshAccessToken({callback: function() {
            window.location.reload();
            //twitchAPI.getTwitchName(data);
          }});
        }
      });
  },
  getUsersById: function(data, callback) {
    const c = this;
    let url = `${apiUrl}users?`;
    for (let i in data) {
      url = `${url}id=${data[i].twitchId}&`;
    }

    axios.get(url, {
        headers: { 
          'Client-ID': clientId,
          'Authorization': `Bearer ${utils.cookies.get('access_token')}` 
        }
      })
      .then(function (response) {
        callback(response.data.data);
      })
      .catch(function (error) {
        if (error.response.status == 401) {
          authentication.refreshAccessToken({callback: function() {
            window.location.reload();
            //twitchAPI.getTwitchName(data);
          }});
        }
      });
  },
  getUserByLogin: function(login, callback) {
    const c = this;
    let url = `${apiUrl}users?login=${login}`;

    axios.get(url, {
        headers: { 
          'Client-ID': clientId,
          'Authorization': `Bearer ${utils.cookies.get('access_token')}` 
        }
      })
      .then(function (response) {
        callback(response.data.data);
      })
      .catch(function (error) {
        if (error.response.status == 401) {
          authentication.refreshAccessToken({callback: function() {
            window.location.reload();
          }});
        }
      });
  }
}
